import type { MechtaIDProfile } from '@mechta-dev/mechta-id-js'
import type { ProfileRes, UserCity } from 'src/entities/profile'
import type { IProfileGateway } from 'src/use-cases/profile/ports/IProfileGateway'
import { apiSeller } from 'api/config'
import { mechtaIDAuthService } from 'src/adapters/auth/mechta-id.service'

// «Вилка»: профиль берётся из Mechta ID (OIDC userinfo), город — из apiSeller.
export class ProfileHttpGateway implements IProfileGateway {
  async getProfile(): Promise<ProfileRes> {
    const profile = await mechtaIDAuthService.getProfile()

    return toProfileRes(profile)
  }

  async getCityInfo(signal?: AbortSignal): Promise<UserCity> {
    const { data } = await apiSeller.get<UserCity>('/user/city', { signal })

    return data
  }
}

function toProfileRes(profile: MechtaIDProfile): ProfileRes {
  const attributes = (profile.attributes ?? {}) as Record<string, unknown>

  return {
    id: profile.sub,
    name: profile.name ?? '',
    phone: profile.phone_number ?? '',
    roles: [...(profile.roles ?? [])],
    permissions: [...(profile.permissions ?? [])],
    subdivisionUtpId: String(attributes.subdivision_utp_id ?? ''),
    utpId: String(attributes.utp_id ?? ''),
    externalId: String(attributes.external_id ?? ''),
  }
}
